import $ from "jquery";
import Cookies from "js-cookie";

import morningstarFunctions from "./morningstar-functions";

const { elementBindings, configuration, cssConfig, getTokenConfig, getFreshToken, handleMorningStarError } =
  morningstarFunctions;

function init(): void {
  const $morningstarElement = $(".js-morningstar-report");

  if (!$morningstarElement.length) {
    return;
  }

  const { tokenApiUrl, universeId, componentId, namespace, environment } = $morningstarElement[0].dataset;

  function loadScreener(token: string) {
    const appConfig = {
      components: {
        ecSecurityReportLoader: {
          type: componentId,
          settings: {
            universeId,
          },
        },
      },
    };
    const settings = {
      angular: elementBindings(componentId),
      lazy: {
        bundlesToDownload: {
          ecSecurityReportLoader: true,
        },
      },
      configuration: configuration(namespace, environment, appConfig),
      apiTokens: getTokenConfig(token),
      css: cssConfig,
    };

    window["morningstar"].loader
      .load(settings)
      .then(function () {
        // (manifest)
        window.console.log("Component loaded successfully");
        const container = document.getElementById("ecSecurityReportLoader-container");
        window["morningstar"].loader.lazyLoad(
          container,
          "report-container",
          "ec-Security-Report-Loader",
          "ecSecurityReportLoader"
        );
        // .then(function () {});
      })
      .catch(function (error: any) {
        handleMorningStarError(error, tokenApiUrl, loadScreener);
      });
  }

  const token = Cookies.get("MSToken");
  if (token) {
    loadScreener(token);
  } else {
    getFreshToken(tokenApiUrl, loadScreener);
  }
}

export default { init };
